import { STYLE_TYPE } from "./magicStrings";

export function debounce(func, delay = 500) {
    let timer = null;
    return function(args) {
        if(timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            func(args);
        }, delay);
    }
};

export const px2vw = (px, size=1440) => {
    return `${px / size * 100}vw`;
};

export const px2percent = (px, size) => {
    return `${px / size * 100}%`
};

export const textLineClamp = (line) => (
    `
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: ${line};
        -webkit-box-orient: vertical;
        display: -webkit-box;
        word-break: break-all;
    `
);

export const maxSize = (size, styleType, cssName, mobileSize) => {
    if(styleType === STYLE_TYPE.BIG_PC) {
        return `${cssName}: ${size}px`
    } else if(styleType === STYLE_TYPE.PC) {
        return `${cssName}: ${px2vw(size)}`;
    } else if(styleType === STYLE_TYPE.MOBILE) {
        return `${cssName}: ${px2vw( mobileSize || size, 375)}`;
    }
};
